import { IProductKeyIconsSizeEnum } from "./types";

import type { IFontSize } from "@interfaces";

export const getIconSize = (sizeName: IProductKeyIconsSizeEnum): IFontSize => {
  switch (sizeName) {
    case IProductKeyIconsSizeEnum.XSmall:
      return "fs-20";
    case IProductKeyIconsSizeEnum.Small:
      return "fs-20";
    case IProductKeyIconsSizeEnum.Medium:
      return "fs-20";
    case IProductKeyIconsSizeEnum.Large:
      return "fs-24";
    case IProductKeyIconsSizeEnum.XLarge:
      return "fs-28";
    case IProductKeyIconsSizeEnum.XXLarge:
      return "fs-32";
    default:
      return "fs-20";
  }
};
